module.exports = __webpack_public_path__ + "static/img/5.c4caf47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduce/5.png
// module id = jfWI
// module chunks = 0